import { Input, CircularProgress } from '@mui/joy';
import { InlineEditButtons } from './InlineEditButtons';

export function InlineEditControls({ value, onChange, onSave, onCancel, autoFocus = true, isPersisting = false }) {
  const handleKeyDown = (e) => {
    if (isPersisting) return;
    if (e.key === 'Enter') {
      onSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus={autoFocus}
        size="sm"
        disabled={isPersisting}
        sx={{ flexGrow: 1, opacity: isPersisting ? 0.6 : 1 }}
        endDecorator={isPersisting ? <CircularProgress size="sm" /> : null}
      />
      <InlineEditButtons onSave={onSave} onCancel={onCancel} disabled={isPersisting} />
    </>
  );
}

